import { Component, OnInit, Input } from "@angular/core";
import { FormGroup, FormBuilder, FormsModule, ReactiveFormsModule } from "@angular/forms";
import { Router } from "@angular/router";
import { interval } from "rxjs";
import { bounceIn } from "src/app/animations/custom.animation";
import { Plugins } from "@capacitor/core";
import { AuthService } from "@core/auth.service";
import { TranslateService, TranslatePipe } from "@ngx-translate/core";
import { MatIcon } from "@angular/material/icon";
import { IonicModule } from "@ionic/angular";
import { MatProgressSpinner } from "@angular/material/progress-spinner";
const { Browser } = Plugins;

@Component({
    selector: "app-add-payment",
    templateUrl: "./add-payment.component.html",
    styleUrls: ["./add-payment.component.scss"],
    animations: [bounceIn],
    standalone: true,
    imports: [
        MatIcon,
        FormsModule,
        ReactiveFormsModule,
        IonicModule,
        MatProgressSpinner,
        TranslatePipe,
    ],
})
export class AddPaymentComponent implements OnInit {
  addNewCardForm: FormGroup;
  @Input() hideOfferDetails: boolean;
  @Input() hideForAddPaymentMethod: boolean;
  firstTimeOffers = [
    "10 EuroMillions lines",
    "10 UK Millionaire Maker entries",
    "Join today - we'll throw in 5 FREE Instant win games - win up to £7k!",
  ];
  isCardAvailable = false;
  spinnerAnimation: boolean;
  progressBar: number;
  proceed: boolean = true;

  constructor(
    private fb: FormBuilder,
    private router: Router,
    private authService: AuthService,
    public translate: TranslateService
  ) {
    this.authService?.selectedlanguage$?.subscribe(
      (l) => {
        if (l) {
          translate.use(l ? l : "en");
        }
      },
      (err) => {
        return err;
      }
    );

    if (!this.isCardAvailable) {
      this.openPaymentOnBrowser();
    }
    this.validateNewCardForm();
  }

  ngOnInit() {}

  ionViewDidEnter() {
    /* Customizing the ion-checkbox tick mark width */
    try{
      const checkboxes = document.querySelectorAll("ion-checkbox");
      checkboxes.forEach((dropDown) => {
        if (!dropDown || (dropDown && !dropDown?.shadowRoot)) return;
        dropDown && dropDown?.shadowRoot
          ? dropDown?.shadowRoot?.querySelectorAll("svg").forEach((elem) => {
              elem.querySelectorAll("path").forEach((tickmark) => {
                tickmark.setAttribute("style", "stroke-width: 2px");
              });
            })
          : "";
      });

    } catch(e){
      
    }
  }

  validateNewCardForm() {
    this.addNewCardForm = this.fb.group({
      cardNumber: [""],
      holderName: [""],
      expiryDate: [""],
      cvcCode: [""],
    });
  }

  onSubmit() {
    this.spinnerAnimation = true;
    this.progressBar = 0;
    const timer$ = interval(20);

    const sub = timer$?.subscribe(
      (sec) => {
        this.progressBar = 0 + sec;

        if (this.progressBar === 100) {
          sub?.unsubscribe();
          setTimeout(() => {
            this.spinnerAnimation = false;
            this.proceed = false;
            setTimeout(() => {
              this.proceed = true;
            }, 3000);
          }, 2000);
        }
      },
      (err) => {
        return err;
      }
    );
  }

  async openPaymentOnBrowser() {
    await Browser.open({
      url: "https://lottosocial.com/webview-auth/?redirect_to=free-reg-step4c/?Prosub_ID=3225&auto_login_token_validate=MTA3NDE6NjE5MzY2ODItMzY2OC00NDgyLThDRjEtOENFNjE1QUJGNDMxOjE2MDQ3NDAzMDk=&time=112221",
    });
    setTimeout(() => {
      Browser.close();
      this.authService.salesLink.next({
        destination: "payment",
        syndicate_id: "020000002B02D7CE7F3C2EDA25314D4B8729A0CF9FAAF825360D16A08EB88EEC3BF5BD04",
      });
      this.router.navigate(["paymentConfirmation"]);
    }, 25000);
  }
}
